import { useState } from "react";
import { Snackbar, TextField } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import withLoader from "../../../components/layouts/WithLoader";
import UploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import SalesService from "../../../services/SellingService";

const TransfertAccountsVirement = ({ startLoading, stopLoading }) => {
  const [datePayement, setDatePayement] = useState("");
  const [codeVirement, setCodeVirement] = useState("");
  const [fileName, setFileName] = useState("");
  const [openInfoAlert, setOpenInfoAlert] = useState(false);

  const [infoAlertText, setInfoAlertText] = useState();
  const [file, setFile] = useState([]);

  const [amount, setAmount] = useState();

  const changeDatePayement = (event) => {
    setDatePayement(event.target.value.concat(":59"));
  };
  const changeAmount = (event) => {
    setAmount(event.target.value);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const changeCodePayementVirement = (event) => {
    setCodeVirement(event.target.value);
  };

  const onUploadFileHandler = (e) => {
    if (e.target.files[0].size > 2097152) {
      setOpenInfoAlert(true);
      setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      setFileName(e.target.files[0].name);

      setFile(e.target.files[0]);
    }
  };

  const payerBill = (e) => {
    if (codeVirement === "") {
      console.log("codeVirement", codeVirement);
      // toast.error("Erreur : le champ  code chéque est vide");
    } else if (datePayement === "") {
      console.log("datePayement", datePayement);
    } else if (amount === "") {
      console.log("amount", amount);
    } else {
      let payFactureOrAvance = {
        idUser: getCurrentUserId(),
        idBaDestination: parseInt(localStorage.getItem("idBaDestination")),
        idBaSource: parseInt(localStorage.getItem("idBaSource")),
        typePayement: 3,
        echanceDate: datePayement,
        ammountPayed: amount,
        urlFile: "any",
        numVirement: codeVirement,
      };
      console.log(payFactureOrAvance);
      startLoading();
      if (file.length !== 0) {
        const uploadData = new FormData();
        uploadData.append("picture", file);

        UploadAndDownloadService.uploadFile(
          "/sales/uploadFileSelling/uploadFile/Payement",
          uploadData
        )
          .then((response) => {
            if (response.data["success"]) {
              payFactureOrAvance.urlFile = response.data.success;
              SalesService.transfertAccount(payFactureOrAvance)
                .then((response) => {
                  console.log(response);
                  if (response.data["error"]) {
                    //   toast.error("Error : il ya un probléme");
                  } else {
                    //   toast.success("ajouté avec succès");
                    // this.refreshPage();
                  }
                })
                .catch((error) => {
                  // toast.error("Error : il ya un probléme");
                });
            } else {
              // toast.error("Erreur : il ya un probléme au niveau de serveur");
            }
          })
          .catch(() => {
            //   toast.error("Erreur : il ya un probléme de connection");
          })
          .finally(() => {
            stopLoading();
          });
      } else {
        startLoading();
        SalesService.transfertAccount(payFactureOrAvance)

          .then((response) => {
            console.log(response);
            if (response.data["error"]) {
              //   toast.error("Error : il ya un probléme");
            } else {
              //   toast.success("ajouté avec succès");
            }
          })
          .catch((error) => {
            console.log("error", error);
          })
          .finally(() => {
            stopLoading();
          });
      }
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <label>Transfert par virement: </label>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <label>Montant : </label>
          <input
            type="number"
            min="0"
            step="0.1"
            //   max={this.props.restToPay.toString()}
            class="form-control"
            placeholder="Montant "
            name="amount"
            value={amount}
            onChange={changeAmount}
          />
        </div>
        <div class="col-md-4">
          <label>Référence virement: </label>
          <input
            value={codeVirement}
            onChange={changeCodePayementVirement}
            class="form-control"
            placeholder="Ref.valeur"
            type="number"
          />
        </div>

        <div class="col-md-4">
          <label>Date de l'échéance </label>
          <br />
          <TextField
            style={{ width: "100%" }}
            className="col-sm-12"
            variant="outlined"
            value={datePayement}
            onChange={changeDatePayement}
            id="datetime-local"
            type="datetime-local"
            defaultValue="date"
            InputLabelProps={{
              shrink: true,
            }}
            size="small"
          />
        </div>
        <div class="col-md-12">
          <div className="row">
            <div className="col-sm-12">
              <div class="form-group">
                <label for="exampleInputFile">Ajouter Virement </label>
                <div class="input-group">
                  <div class="custom-file">
                    <input
                      accept="application/pdf, .jpg, .jpeg, .png"
                      type="file"
                      className="custom-file-input"
                      id="exampleInputFile"
                      onChange={onUploadFileHandler}
                    />
                    <label class="custom-file-label" for="exampleInputFile">
                      {fileName}{" "}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <button
            type="submit"
            onClick={payerBill}
            className="btn btn-dark float-right"
          >
            Payer
          </button>
        </div>
      </div>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};
export default withLoader(TransfertAccountsVirement);
